import { motion } from "framer-motion";
import { ClipboardPaste, PlugZap, FileDown } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: ClipboardPaste,
    title: "Paste URL Batch",
    body: "Drop in a clean list from Ahrefs, Semrush, a spreadsheet, or raw CSV — one URL per line, up to 50 at a time.",
    testid: "how-it-works-step-1",
  },
  {
    n: "02",
    icon: PlugZap,
    title: "MOZ Index Sync",
    body: "SerpBacklink resolves every domain against the MOZ link graph — domain authority, page authority, and spam signals in one pass.",
    testid: "how-it-works-step-2",
  },
  {
    n: "03",
    icon: FileDown,
    title: "Audit & Export",
    body: "Scan the color-graded breakdown in seconds, then copy the table or download a CSV straight into your reporting stack.",
    testid: "how-it-works-step-3",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-24 sm:py-32 border-t border-[#263248]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#D4FF00] mb-4">// Process</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F3F4F6]">
          Three steps. Zero friction.
        </h2>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#263248] border border-[#263248]">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={s.testid}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.12 }}
            className="bg-[#0B0F17] p-8 group hover:bg-[#121824] transition-colors"
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-5xl font-extrabold text-[#D4FF00]/25 group-hover:text-[#D4FF00]/60 transition-colors">
                {s.n}
              </span>
              <s.icon size={22} className="text-[#D4FF00] mt-2" />
            </div>
            <h3 className="mt-8 font-display text-xl sm:text-2xl font-bold text-[#F3F4F6]">{s.title}</h3>
            <p className="mt-3 text-base text-[#9CA3AF] leading-relaxed">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
